import axios from 'axios';

// Base URL for accessing the sector API
const baseURL = process.env.REACT_APP_API_BASE_URL;

// Fetch overview of a given registration
const fetchNetworkGraph = async (entityId: string, type: string) => {
    const path = type === 'sectors' ? 'sector' : 'institution';
    const response = await axios.get(
        `${baseURL}/download/blob?filename=assets/network/${path}/${entityId}.html`
    );
    return response;
};

export const networkGraphAPI = {
    fetchNetworkGraph,
};
